module.exports = __webpack_public_path__ + "img/4.28f4a848.jpg";